import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14ff24d7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ff24d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14ff24d7')) {
      api.createRecord('14ff24d7', component.options)
    } else {
      api.reload('14ff24d7', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=14ff24d7&scoped=true", function () {
      api.rerender('14ff24d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/logistics/strategy/zones/index.vue"
export default component.exports